import { TOPIC_STATISTIC_TYPE } from "constant/topic/topic.const";
import { useTopicStatistic } from "hooks/asocijator/topic/statistic/useTopicStatistic";
import styled from "styled-components";
import { percentageFromTotal } from "./RelatePlayStatistic.logic";
import { DivMarginTop } from "components/common/style/margin/DivMarginTop";

export type RelatePlayStatisticProps = {
  topicId: string;
};

const RelatePlayStatistic = ({ topicId }: RelatePlayStatisticProps) => {
  const topicRelateStatistic = useTopicStatistic({
    topicId,
    statisticType: TOPIC_STATISTIC_TYPE.RELATE_PLAY,
  });

  return (
    <RelatePlayStatisticDiv>
      {topicRelateStatistic && (
        <Div>
          <Div>Total</Div>
          <Div>
            {topicRelateStatistic.total.answerCorrectCount}/
            {topicRelateStatistic.total.charCount}-
            {percentageFromTotal(
              topicRelateStatistic.total.answerCorrectCount,
              topicRelateStatistic.total.charCount
            )}
            %
          </Div>
          <DivMarginTop mt={1}>
            <Div>Topic</Div>
            <Div>
              {topicRelateStatistic.topic.answerCorrectCount}/
              {topicRelateStatistic.topic.charCount}-
              {percentageFromTotal(
                topicRelateStatistic.topic.answerCorrectCount,
                topicRelateStatistic.topic.charCount
              )}
              %
            </Div>
          </DivMarginTop>
        </Div>
      )}
    </RelatePlayStatisticDiv>
  );
};

const RelatePlayStatisticDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-self: start;
  margin-left: 1rem;
`;

const Div = styled.div`
  font-size: 2rem;
`;

export default RelatePlayStatistic;
